/*
 * Author: Dw
 * File Created: Monday, 24-08-05 04:16 pm
 * Last Modified: Monday, 25-03-17 03:20 pm, by Harper Yan
 */
import { Trans, useTranslation } from 'next-i18next';

import { Grid, Stack } from '@mui/material';
import { Flex } from '@ucard/ds/containers';

import Image from '@/components/Image';
import SectionBox from '@/components/LandingContainer/SectionBox';
import { staticImgPrefix, staticPrefix } from '@/utils/prefix';
import { useScreenSize } from '@/utils/screen';

import ScaleText from '../../_components/ScaleText';
import Timeline from '../../_components/TimeLine';
import { StyledCardTitle, Video } from './style';

const Card = () => {
  const { t } = useTranslation('home');

  return (
    <SectionBox
      layerSx={{
        background: '#1A1A1A',
        position: 'relative',
        pb: [10, 17.5],
        pt: [4, 0],
      }}>
      <Grid container>
        <Grid item xs={12}>
          <Stack pt={['24px', '100px']}>
            <ScaleText>
              <StyledCardTitle>
                <Trans
                  components={{ 1: <span /> }}
                  i18nKey="card.title.0"
                  ns="home"
                />
              </StyledCardTitle>
              <StyledCardTitle color="#7E61F3" mt={0.5}>
                {t('card.title.1')}
              </StyledCardTitle>
            </ScaleText>
          </Stack>
        </Grid>
      </Grid>
      <Grid container sx={{ mt: [0, 10] }}>
        <Grid
          alignItems="center"
          display="flex"
          item
          justifyContent="center"
          md={6}
          mt={[4, 0]}
          px={[8, 12, 12, 2, 0]}
          xs={12}>
          <Image
            alt="decard"
            height={540}
            layout="responsive"
            src={staticImgPrefix('/home/home-2-v2.webp')}
            style={{ display: 'block' }}
            width={606}
          />
        </Grid>
        <Grid alignItems="center" display="flex" item md={6} pt={[4, 0]}>
          <Timeline />
        </Grid>
      </Grid>
    </SectionBox>
  );
};

export default Card;
